import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const tiers = [{
  label: 'Board & governance',
  detail: 'Chairs, NEDs and committee chairs'
}, {
  label: 'C-suite',
  detail: 'CEO, CFO, COO, CTO, CHRO'
}, {
  label: 'Executive leadership',
  detail: 'Divisional and functional heads'
}, {
  label: 'Senior management',
  detail: 'Directors and leadership bench'
}];

/** CSS 3D stacked tiers representing the leadership levels mapped in an executive search. */
export function DiamondStack() {
  const [active, setActive] = useState(0);
  const reduce = useReducedMotion();
  return <div className="grid items-center gap-8 sm:grid-cols-[1fr_auto]" data-id="element-563" data-mp="1o0lv51p8aua2">
      <div className="relative mx-auto h-72 w-72" style={{
      perspective: 1100
    }} aria-hidden="true" data-id="element-564" data-mp="1j9x1bfq2tl7r">
        <motion.div className="absolute inset-0" style={{
        transformStyle: 'preserve-3d'
      }} animate={reduce ? undefined : {
        y: [0, -8, 0]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-565" data-mp="vjsxb78z7jg8">
        <div className="absolute inset-0" style={{
          transformStyle: 'preserve-3d',
          transform: 'rotateX(60deg) rotateZ(-45deg)'
        }} data-id="element-566" data-mp="1ub2raogijhky">
          {[...tiers].reverse().map((t, idx) => {
            const i = tiers.length - 1 - idx;
            const size = 120 + idx * 34;
            const isActive = i === active;
            return <div key={t.label} className="absolute left-1/2 top-1/2 rounded-sm border transition-[background-color,border-color] duration-200" style={{
              width: size,
              height: size,
              marginLeft: -size / 2,
              marginTop: -size / 2,
              transform: `translateZ(${(tiers.length - 1 - i) * 36}px)`,
              borderColor: isActive ? '#C9A96E' : 'rgba(147,171,214,0.45)',
              backgroundColor: isActive ? 'rgba(201,169,110,0.22)' : 'rgba(23,41,73,0.55)'
            }} data-id="element-567" data-mp="1bcq9kebjczdr" data-mpi={idx} />;
          })}
        </div>
        </motion.div>
      </div>
      <ul className="space-y-1.5" aria-label="Leadership levels" data-id="element-568" data-mp="264oes70sxpl6">
        {tiers.map((t, i) => <li key={t.label} data-id="element-569" data-mp="2l1f5lrwetsz6" data-mpi={i}>
            <button type="button" onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onClick={() => setActive(i)} aria-pressed={active === i} className={`w-full rounded-md px-3 py-2 text-left transition-colors duration-150 ${active === i ? 'bg-white/10' : 'hover:bg-white/5'}`} data-id="element-570" data-mp="2l0njd7opd7lk">
              <span className={`block text-sm font-medium ${active === i ? 'text-gold-300' : 'text-white'}`} data-id="element-571" data-mp="2232u3zi1070f">{t.label}</span>
              <span className="block text-xs text-white/60" data-id="element-572" data-mp="1xbci7p3fxb6w">{t.detail}</span>
            </button>
          </li>)}
      </ul>
    </div>;
}